<form [formGroup]="form" autocomplete="off">
  <h2 mat-dialog-title>Create space</h2>

  <mat-dialog-content>
    <mat-form-field>
      <mat-label>Space name</mat-label>
      <input
        matInput
        [formControl]="form.controls.name"
        (keydown.enter)="createSpace()"
      />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="primary" (click)="createSpace()">
      Create
    </button>
  </mat-dialog-actions>
</form>
